import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, freddyTheme as theme } from '@coolblue-development/freddy';
const Backdrop = ({ show, switcher }) => {
    return (_jsxs(_Fragment, { children: [_jsx(InteractionTrap, { show: show, onClick: switcher }), _jsx(BackdropElement, { show: show })] }));
};
const InteractionTrap = ({ onClick, show }) => {
    return (_jsx(Box, { onClick: onClick, display: { xs: 'none', md: show ? 'block' : 'none' }, sx: {
            zIndex: 8,
            position: 'fixed',
            left: 0,
            top: '5.2rem',
            width: '100%',
            height: '100%',
        } }));
};
const BackdropElement = ({ show }) => {
    return (_jsx(Box, { display: { xs: 'none', md: 'block' }, sx: {
            userSelect: 'none',
            pointerEvents: 'none',
            zIndex: 7,
            backgroundColor: theme.color.background.interactiveMainBase,
            height: 'calc(100% - 4.8rem)',
            left: 0,
            opacity: show ? 0.15 : 0,
            position: 'fixed',
            top: '4.8rem',
            width: '100%',
            willChange: 'opacity',
            transition: 'opacity 0.25s ease-in-out',
            [theme.breakpoint.minWidth('md')]: {
                top: '5.2rem',
            },
        } }));
};
export { Backdrop };
//# sourceMappingURL=Backdrop.js.map